﻿import React from 'react';
import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Tooltip from '@mui/material/Tooltip';

import {
  blobToDownloadableUrl,
  downloadFileNoExtension,
  csvStringToBlob,
} from '../../../components/Utilities/HelperMethods';

function GenerateCSV(data, columns) {
  if (data == null) return;

  var csvData = '';

  for (let c = 0; c < columns.length; c++) {
    if (c === columns.length - 1) {
      csvData += columns[c].headerName + '\n';
    } else {
      csvData += columns[c].headerName + ',';
    }
  }

  for (let d = 0; d < data.length; d++) {
    const formattedAppReceivedDate = new Date(data[d].appReceivedDate);
    const formattedEstPrem = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(data[d].estimatedPremium);

    csvData +=
      data[d].policyNumber.toString() +
      ',' +
      formattedAppReceivedDate.toLocaleDateString() +
      ',' +
      data[d].pendingStatus +
      `,"${data[d].distributor}",` +
      `"${data[d].agent}",` +
      data[d].npn +
      `,"${data[d].policyOwner}","${data[d].product}","${formattedEstPrem}"\n`;
  }

  var currentDate = new Date().toLocaleDateString().replaceAll('/', '_');
  var csvFileName = 'PendingPolicies_' + currentDate + '.csv';

  csvStringToBlob(csvData).then((result) => {
    const url = blobToDownloadableUrl(result);
    downloadFileNoExtension(url, csvFileName);
  });
}

function ExportButton({ ...props }) {
  return (
    <Tooltip title="Generate CSV based on table below">
      <Button
        variant="contained"
        startIcon={<FileDownloadIcon />}
        onClick={() => {
          GenerateCSV(props.policyData, props.columns);
        }}
      >
        Export
      </Button>
    </Tooltip>
  );
}

export { ExportButton };
